// reducers/door/search.js

export function searchHasErrored(state = false, action) {
  switch (action.type) {
    case 'SEARCH_DOOR_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}

export function searchIsLoading(state = false, action) {
  switch (action.type) {
    case 'SEARCH_DOOR_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}

export function search(state = {}, action) {
  switch (action.type) {
    case 'SEARCH_DOOR_FETCH_DATA_SUCCESS':
      return action.resp;
    default:
      return state;
  }
}